<template>
  <van-dialog v-model="showDialog" :showConfirmButton="false" class="dialog-bud p-4 bg-black text-white"
              title="">
    <slot>
      This is default content
    </slot>
    <img class="img-close" src="../assets/images/close.svg" @click="handleClose"/>
  </van-dialog>
</template>

<script>
export default {
  name: 'BudDialog',
  props: {
    showDialog: Boolean
  },
  methods: {
    handleClose() {
      this.$emit('close-dialog')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dialog-bud {
  overflow: visible !important;
  .img-close {
    position: absolute;
    bottom: -20%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
